module.exports = __webpack_public_path__ + "img/boyfriend-material.13cf52e6.png";